import { useComputedBrands } from "@shared/hooks/games/brands";
import { useGames } from "@shared/hooks/games/games";
import React, { memo, useCallback } from "react";
import { Link } from "react-router-dom";

const AllGames = ({ auth }) => {
  const computedBrands = useComputedBrands();
  const games = useGames();

  const renderLinks = useCallback(
    (brand) => {
      const filteredGames = games.filter(
        (game) => game.game_section_id === brand.id
      );

      return filteredGames.map((game) => (
        <li key={game.id} className="links__item">
          <Link
            to={
              !auth
                ? {
                    pathname: "/",
                    state: { showAuthModal: true },
                  }
                : {
                    pathname: `/games/${game.string_id}`,
                    state: {},
                  }
            }
          >
            {game.name}
          </Link>
        </li>
      ));
    },
    [auth, games]
  );

  return (
    <div>
      {computedBrands.map((brand) => (
        <div
          className="footer-games container"
          key={brand.id}
          style={{ display: !brand.games_count ? "none" : "" }}
        >
          <div className="container__title">{brand.name}</div>

          <ul className="links">{renderLinks(brand)}</ul>
        </div>
      ))}
    </div>
  );
};

export default memo(AllGames);
